export default "__VITE_ASSET__DXxiOXYx__"